export function BurgerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="11"
      fill="none"
      viewBox="0 0 14 11"
    >
      <path
        d="M.959 10.083a.526.526 0 01-.386-.154.518.518 0 01-.156-.383c0-.153.052-.282.156-.387A.519.519 0 01.959 9h12.083c.153 0 .282.051.386.155.104.103.156.23.156.382a.531.531 0 01-.156.388.518.518 0 01-.386.158H.959zm0-2.697a.526.526 0 01-.386-.154.518.518 0 01-.156-.383c0-.153.052-.282.156-.388a.519.519 0 01.386-.158h12.083c.153 0 .282.051.386.154.104.104.156.231.156.383a.531.531 0 01-.156.387.518.518 0 01-.386.16H.959zm0-2.689a.526.526 0 01-.386-.155.518.518 0 01-.156-.382c0-.153.052-.282.156-.388a.519.519 0 01.386-.158h12.083c.153 0 .282.051.386.154.104.103.156.231.156.383a.532.532 0 01-.156.388.519.519 0 01-.386.158H.959zM.959 2a.526.526 0 01-.386-.155.518.518 0 01-.156-.383c0-.152.052-.28.156-.387A.519.519 0 01.959.917h12.083c.153 0 .282.051.386.154.104.103.156.23.156.383a.531.531 0 01-.156.387.518.518 0 01-.386.159H.959z"
        className="fill-deepBlue"
      />
    </svg>
  );
}
